import React, { FC, useState } from 'react';
import { DualMeasure } from '@fullstory/proto/fs/api/metrics';
import { AdvancedDimensionOptionsModal } from '../AdvancedDimensionOptionsModal';
import { AdvancedOptionsLink } from '../AdvancedOptionsLink';

export interface AdvancedDimensionOptionsLinkProps {
  value: DualMeasure;
  onChange: (measure: DualMeasure) => void;
}

/** Link that launches modal to configure "advanced options" for dimensions, i.e. apply to all / first metric event. */
export const AdvancedDimensionOptionsLink: FC<AdvancedDimensionOptionsLinkProps> = ({
  value,
  onChange,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <AdvancedOptionsLink
      onClick={() => setModalOpen(true)}
      data-component="AdvancedDimensionOptionsLink"
    >
      <AdvancedDimensionOptionsModal
        value={value}
        onChange={onChange}
        onCloseSignal={() => setModalOpen(false)}
        open={isModalOpen}
      />
    </AdvancedOptionsLink>
  );
};
